module.exports = __webpack_public_path__ + "img/en.53c05316.png";